<template>
    <div class="software-page">
        <h1>Smart Building Solution</h1>
        <!-- 头部深色区域：还原参考图的质感 -->
        <section class="detail-gallery-section">
            <template>
                <div class="detail-text-block">
                    <p>fdasfdsafdsafdsafjdksalnfdklsanfkldnsaklfndsklnfdslkanflkdsnaklfndsanfdksl</p>
                </div>
                <div class="detail-gallery-item">
                    <el-image src="https://qiniu-us.wifigsmalarm.com/images/solutions/hotel_solution_1.jpg"
                        class="detail-media" lazy>
                    </el-image>
                </div>
            </template>
        </section>


    </div>
</template>

<script setup>

</script>

<style scoped>
/* =========================================
   全局与基础样式
   ========================================= */
.software-page {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    width: 100%;
    overflow-x: hidden;
}

.pc-only {
    display: block;
}

.detail-gallery-section {
    border-top: 2px solid #f2f2f2;
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    align-items: center;
}

.detail-gallery-item {
    width: 100%;
    /* max-width: 900px; */
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* 统一修改为 detail-media 适用视频和图片 */
.detail-media {
    width: 100%;
    height: auto;
    border-radius: 6px;
    display: block;
    object-fit: contain;
}

.detail-caption {
    text-align: center;
    margin-top: 14px;
    max-width: 800px;
}

.detail-caption h3 {
    font-size: 18px;
    margin: 0 0 6px 0;
    color: #111;
}

.detail-caption p {
    font-size: 14px;
    color: #666;
    margin: 0;
    line-height: 1.6;
}

/* =========================================
   移动端适配 (Mobile Responsive)
   ========================================= */
@media screen and (max-width: 768px) {
    .pc-only {
        display: none;
    }

    .detail-gallery-section {
        margin-left: -20px;
        margin-right: -20px;
        padding-top: 30px;
    }

    .detail-media {
        border-radius: 0;
        /* 手机端去掉圆角，让图片完全贴合屏幕边缘 */
    }

    .detail-caption {
        padding: 0 20px;
        /* 图片通栏了，但文字需要加回内边距防止贴边 */
    }
}
</style>